import { ClassNameProps } from "@/types";
import { AssetResponse } from "@/utils/FetchAssetDetails/types";

enum Tile169Size {
  Medium = "medium",
  Large = "large",
  XLarge = "xlarge",
}

interface Tile169Props extends ClassNameProps {
  asset: AssetResponse;
  tileSize: Tile169Size;
  progress?: number;
}

export { Tile169Size };
export type { Tile169Props };
